// extracted by mini-css-extract-plugin
export var bodySections = "_4r-8";
export var gray = "_4r-7";
export var green = "_4r-4";
export var iconContainer = "_4r-9";
export var iconWidgetContainer = "_4r-1";
export var phoneIcon = "_4r-2";
export var red = "_4r-5";
export var statusDot = "_4r-3";
export var widgetContainer = "_4r-0";
export var yellow = "_4r-6";